import React from 'react';
import DividerWithText from '../components/Utils/Divider';
import { Countdown } from '../components/CountDown/CountDown';
export default function About() {
  return (
    <div>
      <div
        style={{
          justifyContent: 'center',
          display: 'flex',
        }}
      >
        <Countdown />
      </div>
      <DividerWithText />
    </div>
  );
}
